export default __webpack_public_path__ + "static/navbar-bg-67dcac4aea9e78ff1480f1f4c6898231.png";